export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";